import type { ReactNode } from 'react';
import type { Shelf } from '@/api/types';
import { EntityAutocomplete } from './EntityAutocomplete';
import { searchShelves, createShelf } from '@/api/shelves';

export interface ShelfAutocompleteProps {
  value: Shelf | null;
  onChange: (value: Shelf | null) => void;
  label?: string;
  disabled?: boolean;
  allowCreate?: boolean;
}

export function ShelfAutocomplete({
  value,
  onChange,
  label = 'Полка',
  disabled = false,
  allowCreate = true,
}: ShelfAutocompleteProps): ReactNode {
  return (
    <EntityAutocomplete
      value={value}
      onChange={onChange}
      label={label}
      disabled={disabled}
      allowCreate={allowCreate}
      searchFunction={searchShelves}
      createFunction={createShelf}
    />
  );
}
